import firebase from "../config/firebase";
require("firebase/auth");

const db = firebase.firestore();

const xmlDocumentNFeService = {
  async getAllXMLDocumentsNFe(viewALL, userUids) {
    let query = db.collection("xml_document_nfe").limit(1000);

    if (!viewALL && userUids.length > 0) {
      if (userUids.length === 1) {
        query = query.where("uidShipper", "==", userUids[0]);
        if (query.length === 0) {
          query = query.where("uid", "==", userUids[0]);
        }
      } else {
        query = query.where("uidShipper", "in", userUids);
        if (query.length === 0) {
          query = query.where("uid", "in", userUids);
        }
      }
    }

    return query.get();
  },

  async getProviderByCnpj(cnpj) {
    return await firebase
      .firestore()
      .collection("xml_document_nfe")
      .where("cpfcnpj", "==", cnpj)
      .get();
  },

  async getProviderByChaveNFe(chaveNFe, userUids, viewALL) {
    let query = db.collection("xml_document_nfe");

    if (!viewALL && userUids.length > 0) {
        if (userUids.length === 1) {
          query = query.where("uidShipper", "==", userUids[0]);
          if (query.length === 0) {
            query = query.where("uid", "==", userUids[0]);
          }
        } else {
          query = query.where("uidShipper", "in", userUids);
          if (query.length === 0) {
            query = query.where("uid", "in", userUids);
          }
        }
    }

    query = query.where("chave", "==", chaveNFe);
    return query.get();
  },

  async getProviderByNumberNF(numberNF, userUids, viewALL) {
    let query = db.collection("xml_document_nfe");

    if (!viewALL && userUids.length > 0) {
        if (userUids.length === 1) {
          query = query.where("uidShipper", "==", userUids[0]);
          if (query.length === 0) {
            query = query.where("uid", "==", userUids[0]);
          }
        } else {
          query = query.where("uidShipper", "in", userUids);
          if (query.length === 0) {
            query = query.where("uid", "in", userUids);
          }
        }
    }

    query = query.where("nNF", "==", numberNF);

    return query.get();
  },
  async getProviderByDateInitialAndFinaly(initialDate, finallyDate, userUids, viewALL) {    
    let query = db.collection("xml_document_nfe");

    if (!viewALL && userUids.length > 0) {
        if (userUids.length === 1) {
          query = query.where("uidShipper", "==", userUids[0]);
          if (query.length === 0) {
            query = query.where("uid", "==", userUids[0]);
          }
        } else {
          query = query.where("uidShipper", "in", userUids);
          if (query.length === 0) {
            query = query.where("uid", "in", userUids);
          }
        }
    }

    query = query
        .where("dhEmi", ">=", initialDate)
        .where("dhEmi", "<=", finallyDate);
    return query.get();
  },

  async createDocumentProvider(data) {
    try {
      const docRef = await firebase
        .firestore()
        .collection("xml_document_nfe")
        .add(data);
      return docRef.id; // Retorna o ID do regsitro criado.
    } catch (error) {
      console.error("Error ### Erro  ao salvar o documento XML NFe!", error);
      throw error; // Propaga o erro para tratamento posterior, se necessário
    }
  },

  async updateDocumentProvider(id, newData) {
    firebase
      .firestore()
      .collection("xml_document_nfe")
      .doc(id)
      .update(newData)
      .catch((error) => {
        console.log(error);
      });
  },

  async deleteDocumentProvider(id) {
    try {
      const docRef = firebase
        .firestore()
        .collection("xml_document_nfe")
        .doc(id);
      await docRef.delete();
    } catch (error) {
      console.error("Erro ao excluir documento: ", error);
    }
  },
};

export default xmlDocumentNFeService;
